<template>
  <div
    id="wrapper"
    class="clearfix"
  >
    <!-- Content
		============================================= -->
		
    <div
      class="timeline"
    >
      <h1
        class="text-4xl"
        style="color: #1a1f56;"
      >
        DEDUCTION TIMELINE
      </h1>

      
      
      <div
        v-for="i in indexArr"
      >
	  	


		<div
            class="timeline__event  animated fadeInUp"
            :class="delayClass(i)"
          >
            <div class="timeline__event__icon ">
              <i class="icon">2026</i>
              <div class="timeline__event__date">
                {{ moment(DEDUCTIONSCHEDULE[i]).format("MMM DD") }}
              </div>
            </div>
            <div class="timeline__event__content ">
              <div class="table-wrapper">
                <div class="d-flex flex-column">
                  <div class="timeline__event__title">
                    DEDUCTIONS
                  </div>
                  <div
                    class="d-flex flex-column"
                    style="font-size: 11px;color:#6b7280;"
                  >
                    
                    
                    <template v-if="deductionFlagArr[i]">
                      <div class="d-flex flex-row">
                        <p class="flex-grow-1 mr-2 text-left">
                          WinWin Staff Lottery
                        </p>
                        <p v-if="deductionMainArr[i]" class="justify-end flex-grow-1 text-right">
                          ${{ deductionMainArr[i] }}
                        </p>
                        <p v-else class="justify-end flex-grow-1 text-right">
                          $0
                        </p>
                      </div>
                      <div class="d-flex flex-row">
                        <p class="flex-grow-1 mr-2 text-left">
                          Quarterly Cash 50|50
                        </p>
                        <p v-if="deduction50Arr[i]" class="justify-end flex-grow-1 text-right">
                          ${{ deduction50Arr[i] }}
                        </p>
                        <p v-else class="justify-end flex-grow-1 text-right">
                          $0
                        </p>
                      </div>
                    </template>
                    <template v-else>
                      <div class="timeline__event__description text-left">
                        <p>NO DEDUCTION</p>
                      </div>
                    </template>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>


		
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import { DEDUCTIONSCHEDULE, WINWINMAINPACKAGES, WINWIN5050PACKAGES } from "../utils/constants"
    export default {
        name: "DeductionSchedule",
        props: ["user", "payPeriods"],
        data() {
            return {
                delay: 3,
                DEDUCTIONSCHEDULE
            }
        },
        computed:{
          indexArr(){
            const arr = new Array(26);
            for (let i=0; i<arr.length; i++){
              arr[i] = i;
            }
            return arr;
          },
          deductionMainArr(){
            const arr = new Array(26);
            
            // arr[0] = this.user.apiData.Profile.f_PP01TempDeductionMain;
            // arr[1] = this.user.apiData.Profile.f_PP02TempDeductionMain;
            // arr[2] = this.user.apiData.Profile.f_PP03TempDeductionMain;
            // arr[3] = this.user.apiData.Profile.f_PP04TempDeductionMain;

            /**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
            arr[0] = this.user.apiData.Profile.f_PP01DeductionMain;
            arr[1] = this.user.apiData.Profile.f_PP02DeductionMain;
            arr[2] = this.user.apiData.Profile.f_PP03DeductionMain;
            arr[3] = this.user.apiData.Profile.f_PP04DeductionMain;
            arr[4] = this.user.apiData.Profile.f_PP05DeductionMain;
            arr[5] = this.user.apiData.Profile.f_PP06DeductionMain;
            arr[6] = this.user.apiData.Profile.f_PP07DeductionMain;
            arr[7] = this.user.apiData.Profile.f_PP08DeductionMain;
            arr[8] = this.user.apiData.Profile.f_PP09DeductionMain;
            arr[9] = this.user.apiData.Profile.f_PP10DeductionMain;
            arr[10] = this.user.apiData.Profile.f_PP11DeductionMain;
            arr[11] = this.user.apiData.Profile.f_PP12DeductionMain;
            arr[12] = this.user.apiData.Profile.f_PP13DeductionMain;
            arr[13] = this.user.apiData.Profile.f_PP14DeductionMain;
            arr[14] = this.user.apiData.Profile.f_PP15DeductionMain;
            arr[15] = this.user.apiData.Profile.f_PP16DeductionMain;
            arr[16] = this.user.apiData.Profile.f_PP17DeductionMain;
            arr[17] = this.user.apiData.Profile.f_PP18DeductionMain;
            arr[18] = this.user.apiData.Profile.f_PP19DeductionMain;
            arr[19] = this.user.apiData.Profile.f_PP20DeductionMain;
            arr[20] = this.user.apiData.Profile.f_PP21DeductionMain;
            arr[21] = this.user.apiData.Profile.f_PP22DeductionMain;
            arr[22] = this.user.apiData.Profile.f_PP23DeductionMain;
            arr[23] = this.user.apiData.Profile.f_PP24DeductionMain;
            arr[24] = this.user.apiData.Profile.f_PP25DeductionMain;
            arr[25] = this.user.apiData.Profile.f_PP26DeductionMain;

            return arr;
          },
          deduction50Arr(){
            const arr = new Array(26);
            
            // arr[0] = this.user.apiData.Profile.f_PP01TempDeduction50;
            // arr[1] = this.user.apiData.Profile.f_PP02TempDeduction50;
            // arr[2] = this.user.apiData.Profile.f_PP03TempDeduction50;
            // arr[3] = this.user.apiData.Profile.f_PP04TempDeduction50;

            /**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
            arr[0] = this.user.apiData.Profile.f_PP01Deduction50;
            arr[1] = this.user.apiData.Profile.f_PP02Deduction50;
            arr[2] = this.user.apiData.Profile.f_PP03Deduction50;
            arr[3] = this.user.apiData.Profile.f_PP04Deduction50;
            arr[4] = this.user.apiData.Profile.f_PP05Deduction50;
            arr[5] = this.user.apiData.Profile.f_PP06Deduction50;
            arr[6] = this.user.apiData.Profile.f_PP07Deduction50;
            arr[7] = this.user.apiData.Profile.f_PP08Deduction50;
            arr[8] = this.user.apiData.Profile.f_PP09Deduction50;
            arr[9] = this.user.apiData.Profile.f_PP10Deduction50;
            arr[10] = this.user.apiData.Profile.f_PP11Deduction50;
            arr[11] = this.user.apiData.Profile.f_PP12Deduction50;
            arr[12] = this.user.apiData.Profile.f_PP13Deduction50;
            arr[13] = this.user.apiData.Profile.f_PP14Deduction50;
            arr[14] = this.user.apiData.Profile.f_PP15Deduction50;
            arr[15] = this.user.apiData.Profile.f_PP16Deduction50;
            arr[16] = this.user.apiData.Profile.f_PP17Deduction50;
            arr[17] = this.user.apiData.Profile.f_PP18Deduction50;
            arr[18] = this.user.apiData.Profile.f_PP19Deduction50;
            arr[19] = this.user.apiData.Profile.f_PP20Deduction50;
            arr[20] = this.user.apiData.Profile.f_PP21Deduction50;
            arr[21] = this.user.apiData.Profile.f_PP22Deduction50;
            arr[22] = this.user.apiData.Profile.f_PP23Deduction50;
            arr[23] = this.user.apiData.Profile.f_PP24Deduction50;
            arr[24] = this.user.apiData.Profile.f_PP25Deduction50;
            arr[25] = this.user.apiData.Profile.f_PP26Deduction50;

            return arr;
          },
          deductionFlagArr(){
            const arr = new Array(26);
            
            // arr[0] = this.user.apiData.Profile.f_PP01Temp;
            // arr[1] = this.user.apiData.Profile.f_PP02Temp;
            // arr[2] = this.user.apiData.Profile.f_PP03Temp;
            // arr[3] = this.user.apiData.Profile.f_PP04Temp;
            
            /**
             * Pay period fields from previous year will be reset after the 4th pay period and
             * Temp data (PP01Temp,PP02Temp... PP04Temp) will be transfer overt to fields PP01-PP26. 
             * That is when these fields should be uncommented and the 4 fields above commented
             */
            arr[0] = this.user.apiData.Profile.f_PP01;
            arr[1] = this.user.apiData.Profile.f_PP02;
            arr[2] = this.user.apiData.Profile.f_PP03;
            arr[3] = this.user.apiData.Profile.f_PP04;
            arr[4] = this.user.apiData.Profile.f_PP05;
            arr[5] = this.user.apiData.Profile.f_PP06;
            arr[6] = this.user.apiData.Profile.f_PP07;
            arr[7] = this.user.apiData.Profile.f_PP08;
            arr[8] = this.user.apiData.Profile.f_PP09;
            arr[9] = this.user.apiData.Profile.f_PP10;
            arr[10] = this.user.apiData.Profile.f_PP11;
            arr[11] = this.user.apiData.Profile.f_PP12;
            arr[12] = this.user.apiData.Profile.f_PP13;
            arr[13] = this.user.apiData.Profile.f_PP14;
            arr[14] = this.user.apiData.Profile.f_PP15;
            arr[15] = this.user.apiData.Profile.f_PP16;
            arr[16] = this.user.apiData.Profile.f_PP17;
            arr[17] = this.user.apiData.Profile.f_PP18;
            arr[18] = this.user.apiData.Profile.f_PP19;
            arr[19] = this.user.apiData.Profile.f_PP20;
            arr[20] = this.user.apiData.Profile.f_PP21;
            arr[21] = this.user.apiData.Profile.f_PP22;
            arr[22] = this.user.apiData.Profile.f_PP23;
            arr[23] = this.user.apiData.Profile.f_PP24;
            arr[24] = this.user.apiData.Profile.f_PP25;
            arr[25] = this.user.apiData.Profile.f_PP26;
            return arr;
          },
        },
        methods: {
            moment: function (date) {
                return moment(date);
            },
            delayClass(index) {
                switch (index) {
                    case 0:
                        return 'delay-3s'
                        break;
                        case 1:
                            return 'delay-2s'
                            break;
                            case 2:
                                return 'delay-3s'
                                break;
                                default:
                                    return ''
                }
            },
            getMainTicketPackageByValue(val) {
                                
				var ticketPackage = WINWINMAINPACKAGES.find(x=>x.Cost == val)
				if (ticketPackage) return ticketPackage.PackageName

				return ''
				
			},
			get5050TicketPackageByValue(val) {
                                
					var ticketPackage = WINWIN5050PACKAGES.find(x=>x.Cost == val)
					if (ticketPackage) return ticketPackage.PackageName

					return ''
				
			},
        }
    }
</script>

<style scoped>


		.timeline {
		  display: flex;
		  flex-direction: column;
		  max-width: 50%;
		  margin: 5% auto;
		}
		.timeline__event {
		  background: #fff;
		  margin-bottom: 20px;
		  position: relative;
		  display: flex;
		  margin: 20px 0;
		  border-radius: 8px;
		  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25), 0 18px 36px -18px rgba(0, 0, 0, 0.3), 0 -12px 36px -8px rgba(0, 0, 0, 0.025);
		}
		.timeline__event__title {
		  font-size: 1rem;
		  line-height: 1.4;
		  text-transform: uppercase;
		  font-weight: 600;
		  color: #1a1f56;
		  letter-spacing: 1.5px;
		  text-align: left;
		}
		.timeline__event__content {
		  padding: 15px;
          width: 100%;
		}
		.timeline__event__date {
		  color: #c1b598;
		  font-size: 1rem;
		  font-weight: 400;
		  white-space: nowrap;
		}
		.timeline__event__icon {
		  font-family: "Poppins", sans-serif;
		  border-radius: 8px 0 0 8px;
		  background: #1a1f56;
		  display: flex;
		  align-items: center;
		  justify-content: center;
		  flex-basis: 20%;
		  font-size: 1rem;
		  color: #c1b598;
		  padding: 20px;
		}
		.timeline__event__icon i {
		  position: absolute;
		  top: 50%;
		  left: -67px;
		  font-size: 0.75rem;
		  transform: translateY(-50%);
		  font-family: "Poppins", sans-serif;
		}
		.timeline__event__description {
		  flex-basis: 60%;
		  font-size: 12px;
		}
		.timeline__event::after {
		  content: "";
		  width: 3px;
		  height: 100%;
		  background: #1a1f56;
		  position: absolute;
		  top: 52%;
		  left: -3.5rem;
		  z-index: -1;
		}
		.timeline__event::before {
		  content: "";
		  width: 5rem;
		  height: 5rem;
		  position: absolute;
		  background: #1a1f56;
		  border-radius: 100%;
		  left: -6rem;
		  top: 50%;
		  transform: translateY(-50%);
		}

		.timeline__event:last-child:after {
		  content: none;
		}

		@media (max-width: 786px) {
		  .timeline__event {
			flex-direction: column;
		  }

		  .timeline__event__icon {
			border-radius: 4px 4px 0 0;
		  }
		}
	
		/* Table Styles */

		.table-wrapper{
			margin: 0px;
            width: 100%;
		}

		.dd-table {
			font-size: 14px;
			font-weight: normal;
			border: none;
			border-collapse: collapse;
			width: 100%;
			max-width: 100%;
			white-space: nowrap;
			margin-right: 30px;

            th {
                
            background-color: white !important;
            }
		}

		.fl-table td, .fl-table th {
			text-align: left;
		}

		/* Responsive */

		@media (max-width: 767px) {
			.fl-table {
				display: block;
				width: 100%;
			}
			.fl-table thead, .fl-table tbody, .fl-table thead th {
				display: block;
			}
			.fl-table thead {
				float: left;
			}
			.fl-table tbody {
				width: auto;
				position: relative;
				overflow-x: auto;
			}
			.fl-table td, .fl-table th {
				padding: 20px .625em .625em .625em;
				height: 60px;
				vertical-align: middle;
				box-sizing: border-box;
				overflow-x: hidden;
				overflow-y: auto;
				width: 120px;
				font-size: 13px;
				text-overflow: ellipsis;
			}
			.fl-table thead th {
				text-align: left;
				border-bottom: 0px solid #f7f7f9;
			}
			.fl-table tbody tr {
				display: table-cell;
			}
			.fl-table tbody td {
				display: block;
				text-align: left;
			}
		}
	
	
	
	</style>